import useSWRMutation from 'swr/mutation';
import { createNewPasswordRequest, type CreateNewPasswordParams } from '../requests';

export const useCreateNewPasswordMutation = () => {
  const { trigger, isMutating, error, reset } = useSWRMutation(
    'create-new-password-mutation',
    (_, { arg }: { arg: CreateNewPasswordParams }) => createNewPasswordRequest(arg),
  );

  return {
    createNewPassword: trigger,
    isCreatingNewPassword: isMutating,
    createNewPasswordError: error,
    resetCreateNewPassword: reset,
  };
};
